/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import { useInput } from 'react-admin';
import _map from 'lodash/map';
import _get from 'lodash/get';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';

import useFetchCategories from '../hooks/useFetchCategories';

export default function (props) {
  const { loading, categories: assetCategories } = useFetchCategories(
    props.record.type
  );
  const categories = _get(props, 'record.categories', []);

  const {
    input: { onChange },
    meta: { touched, error },
  } = useInput(props);

  return (
    <>
      <Autocomplete
        multiple
        loading={loading}
        options={_map(assetCategories, (c) => c.id)}
        onChange={(_, value) => onChange(value)}
        defaultValue={categories}
        freeSolo
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label}
            variant="standard"
            error={!!(touched && error)}
            helperText={touched && error && error[props.source]}
          />
        )}
      />
      {touched && error && (
        <p
          class="MuiFormHelperText-root MuiFormHelperText-contained Mui-error MuiFormHelperText-marginDense"
          id="extraData.ref-helper-text"
        >
          {error}
        </p>
      )}
    </>
  );
}
